import React, { useMemo } from 'react';

const DetailDataContext = React.createContext({});

/**
 * Supplies a detail surface's widgets with the record they draw and the actions they offer.
 *
 * A widget reads this rather than taking props, so the page never learns which widgets a layout
 * placed and a widget works wherever it is placed. Live values need nothing of it: they reach a
 * widget through the atoms they always have.
 *
 * @param {Object} value - The record, the state around it, and the handlers it offers.
 *
 * @returns {React.JSX.Element}
 */
export const DetailDataProvider = function DetailDataProvider({
  value = null,
  children,
}) {
  const provided = useMemo(() => value ?? {}, [value]);

  return (
    <DetailDataContext.Provider value={provided}>
      {children}
    </DetailDataContext.Provider>
  );
};

/**
 * What the page publishes to the widgets below it.
 *
 * @returns {Object}
 */
export const useDetailData = () => React.useContext(DetailDataContext);

export default DetailDataProvider;
